<bx-card>
  <bx-card-header [divider]="false" [title]="title() | translate"></bx-card-header>

  <div class="gap-3xl pt-2xl pr-3xl pb-3xl pl-3xl flex w-full justify-between">
    @for (dataPoint of data(); track $index) {
      <div class="gap-md flex flex-col text-nowrap">
        <div class="gap-xs flex items-center">
          <svg-icon fontSize="20px" [key]="dataPoint.icon" [class]="dataPoint.iconStyle" />
          <span class="text-text-tertiary-600 text-sm font-medium" data-testid="currentStatePanelLabel">{{ dataPoint.label }}</span>
        </div>
        @if (hasSubLabels()) {
          <span class="text-text-primary-900 min-h-4 pl-6 text-xs font-medium">{{ dataPoint.subLabel }}</span>
        }
        @if (!dataPoint.href) {
          <span
            class="text-text-brand-primary-900 pl-6 text-sm font-semibold whitespace-nowrap"
            [class]="dataPoint.valueStyle"
            data-testid="currentStatePanelValue"
          >
            {{ dataPoint.value }}
          </span>
        } @else {
          <a
            [href]="dataPoint.href"
            class="text-text-brand-primary-900 pl-6 text-sm font-semibold whitespace-nowrap underline"
            data-testid="currentStatePanelValue"
          >
            {{ dataPoint.value }}
          </a>
        }
      </div>
    }
  </div>
</bx-card>
